import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const tenantApi = createApi({
  reducerPath: 'tenantApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['ModuleConfig', 'Branding', 'TenantConfig'],
  endpoints: () => ({})
})

export default tenantApi
